import bgHome from "../assets/images/background.svg";
import "../assets/css/Home.css";

export default function Home() {
  return (
    <div className="main-home">
      <div className="img-banner">
        <img src={bgHome} alt="bgImg" className="b-img" />
      </div>
      <div className="about-game">
        <h2>About The Game</h2>
        <p>
          This learning game is designed especially for young learners aged 3
          years and above. It supports kids in their early school journey and
          helps them build strong foundational skills with ease. Every activity
          inside the game is created to match how children naturally learn so
          they can explore new ideas without feeling pressured. The goal of the
          game is simple: make learning fun and meaningful. Each lesson is
          presented through interactive play, colourful visuals, storytelling,
          and age-friendly challenges that turn education into an enjoyable
          experience. As kids progress through the game, they develop
          confidence, improve their thinking abilities, sharpen their academic
          skills, and stay curious about the world around them. The game
          includes a wide range of early-learning activities such as basic
          number learning, shape recognition, colour matching, colour filling,
          and many other engaging tasks designed to strengthen problem-solving
          and observation skills. It also gives parents the assurance that their
          child is learning in a safe, engaging, and structured environment that
          supports early school education.
        </p>
      </div>
    </div>
  );
}
